import {SaveAlt} from '@mui/icons-material';
import {CommissionsReport} from 'Agent/Commissions/ducks/a360CommissionsReport';
import {DateTime} from 'luxon';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import FileDownloadButton from 'Shared/components/FileDownloadButton';
import {FileExtension} from 'Shared/components/FileDownloadLink';
import {RequestMethod} from 'Shared/utilities/fetchHelpers';
import {A360CommissionSection} from '../CommissionSection';
import { extractProducerCodes } from '../utilities';

const exportToCsvConfig = {
  startIcon: <SaveAlt />,
  extension: FileExtension.CSV,
  children: 'Export To CSV',
  requestMethod: RequestMethod.POST,
  displayTooltip: false,
};

const getReportNameAndLocation = (report: CommissionsReport, selectedDate: DateTime) => {
  const month = selectedDate.toFormat('MM');
  const year = selectedDate.toFormat('yyyy');
  switch (report) {
    case CommissionsReport.DEFERRED:
      return {downloadedFileName: `Commissions_Report_Deferred_${month}-${year}`, relativeFileLocation: ''};
    case CommissionsReport.EARNED_ACTIVITY:
      return {
        downloadedFileName: `Commissions_Report_EarnedActivity_${month}-${year}`,
        relativeFileLocation: '/api/commissions/v1/commissionsReport/earnedActivity/csv',
      };
    case CommissionsReport.ORDINARY:
      return {
        downloadedFileName: `Commissions_Report_Ordinary_${month}-${year}`, 
        relativeFileLocation: '/api/commissions/v1/commissionsReport/ordinary/csv',
      };
    default:
      return {downloadedFileName: `Commissions_Report_${month}-${year}`, relativeFileLocation: ''};
  }
};

export const ExportReportToCSV = () => {
  const {
    filter: {selectedDate, selectedProducerCodes, selectedReport},
  } = useSelector((state: ReducerState) => state.a360CommissionsReport);

  const {downloadedFileName, relativeFileLocation} = getReportNameAndLocation(selectedReport, selectedDate);

  const csvProps = {
    requestPayload: {
      producerCodes: extractProducerCodes(selectedProducerCodes),
      endMonth: selectedDate.toFormat('MM'),
      endYear: selectedDate.toFormat('yyyy'),
    },
    downloadedFileName,
    relativeFileLocation,
    ...exportToCsvConfig,
  };

  return (
    <A360CommissionSection
      align="center"
      className="a360_commissions_reporting-export-report"
      aria-label="commissions report export to csv"
    >
      <FileDownloadButton
        {...csvProps}
        aria-label="Export To CSV"
        variant="contained"
        color="primary"
        gridOverrideClassName="a360-commissions-grid__toolbar-csv"
      />
    </A360CommissionSection>
  );
};
